import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';

export const BidCredentialCreate = (markets, marketGroup, selectedMarketGroup) => {
    let credentials = {};
    if (markets.some((market) => marketGroup.FCR.includes(market.value))) {
        credentials = {
            BASE_URL: yup.string().required(ERRORS.required),
            USERNAME: yup.string().required(ERRORS.required),
            PASSWORD: yup.string().required(ERRORS.required),
        };
    } else if (
        (markets.some((market) => marketGroup.FCR_D.includes(market.value)) && selectedMarketGroup.value === 'FCR_D') ||
        markets.some((market) => marketGroup.FFR.includes(market.value))
    ) {
        credentials = {
            BID_RESULT_BASE_URL: yup.string().required(ERRORS.required),
            AUTH_TOKEN: yup.string().required(ERRORS.required),
        };
    } else if (markets.some((market) => marketGroup.AFRR.includes(market.value)) || markets.some((market) => marketGroup.MFRR.includes(market.value))) {
        credentials = {
            BASE_URL: yup.string().required(ERRORS.required),
            API_KEY: yup.string().required(ERRORS.required),
            BA_MESSAGE_ID: yup.string().required(ERRORS.required),
            SELF_EIC: yup.string().required(ERRORS.required),
            ENERGY_EIC: yup.string().required(ERRORS.required),
            CAPACITY_EIC: yup.string().required(ERRORS.required),
            ENERGY_ADDRESS: yup.string().required(ERRORS.required),
            CAPACITY_ADDRESS: yup.string().required(ERRORS.required),
            AVAILABILITY_PLANS_ADDRESS: yup.string().required(ERRORS.required),
            RESOURCE_SCHEDULE_ADDRESS: yup.string().required(ERRORS.required),
        };
    } else if (markets.some((market) => marketGroup.DC_PLANNER.includes(market.value))) {
        credentials = {
            BASE_URL: yup.string().required(ERRORS.required),
            USERNAME: yup.string().required(ERRORS.required),
            PASSWORD: yup.string().required(ERRORS.required),
        };
    } else if (markets.some((market) => marketGroup.FCR_D_FT.includes(market.value))) {
        credentials = {
            FORTUM_BASE_URL: yup.string().required(ERRORS.required),
            KEY: yup.string().required(ERRORS.required),
            SECRET: yup.string().required(ERRORS.required),
        };
    }

    return yup.object().shape({
        name: yup.string().required(ERRORS.required),
        market: yup.array().min(1, ERRORS.required).required(ERRORS.required),
        email: yup.string().email(ERRORS.email).required(ERRORS.required),
        ...credentials,
    });
};
